// extracted by mini-css-extract-plugin
module.exports = {"post":"Group-module--post--HY6Xo","textBase":"Group-module--text-base--2RRCm"};